import React from 'react';

/**
 * Photos dealt into fixed columns, the way the gallery's masonry does it.
 *
 * A CSS column layout re-balances every time an image finishes loading,
 * which with fifty unsized thumbnails means the grid shuffles for seconds.
 * Dealing each photo to a column up front means a photo never moves: an
 * image that loads only pushes down the ones below it in its own column.
 */
const columnsOf = (items, count) => {
  const columns = Array.from({ length: count }, () => []);
  items.forEach((item, index) => {
    columns[index % count].push({ item, index });
  });
  return columns;
};

/**
 * A collection's photos at their own shape, each opening the viewer at its
 * index. Shared by the creative form's drawer and the partner app's read of
 * the couple's picks, so the two show a collection the same way.
 */
const PhotoMasonry = ({ media, columnCount, onOpen }) => React.createElement("div", {
  className: "cp-masonry"
}, columnsOf(media, columnCount).map((column, c) => React.createElement("div", {
  className: "cp-masonry-col",
  key: c
}, column.map(({
  item: m,
  index: i
}) => React.createElement("button", {
  type: "button",
  className: "cp-masonry-item",
  key: m.url || i,
  onClick: () => onOpen(i),
  "aria-label": `View reference ${i + 1}`
}, React.createElement("img", {
  src: m.url,
  alt: "",
  loading: "lazy",
  decoding: "async",
  // The tile holds a placeholder shape until its photo arrives. Without
  // it a tile has no height, the column collapses, and a zero-sized
  // lazy image is never fetched at all. Marked on the node rather than
  // in state: fifty of these would otherwise re-render the whole grid
  // fifty times. A broken photo has no size of its own to settle into,
  // so it keeps the placeholder shape rather than collapsing.
  onLoad: e => e.target.parentNode.classList.add('is-loaded'),
  onError: e => e.target.parentNode.classList.add('is-error')
}))))));

export default PhotoMasonry;
